import { JitsiIframeOptions } from '../Interfaces/JitsiIframeOptions';
import axios from 'axios';
export default class JitsiIframeAPI {
    api: any

    options: JitsiIframeOptions;

    constructor(options: JitsiIframeOptions) {
        this.options = options;
    }

    getApi() {
        return this.api;
    }

    async loadScript(source:string) {
        return new Promise<void | string>(async (resolve, reject) => {
            const existing_script = document.querySelector(`script[src="${source}"]`);

            if (existing_script) {
                existing_script.remove()
            }
	/*
            const network_error = await axios.get(source)
                                                .then(response => false)
                                                .catch(error => error.message === 'Network Error')

            if(network_error) {
                return reject('Problema de rede');
            }
            */
            const script = document.createElement("script");

            script.src = source;

            script.type = 'text/javascript';

            script.onload = () => resolve();

            script.onerror = () => reject('Ocorreu um erro ao criar o iframe para a aula.');

            document.head.appendChild(script);
        });
    }

    async startJitsi() {
        await this.loadScript(this.options.scriptSource);

        //@ts-ignore
        this.api = new JitsiMeetExternalAPI(this.options.domain, this.options);

        return this.api;
    }
}
